import type { PlanStrategyType } from '../types';

export const strategyMeta: Record<PlanStrategyType, { key: PlanStrategyType; title: string }> = {
  NAIVE: { key: 'NAIVE', title: 'Naive plan' },
  RTB: { key: 'RTB', title: 'WEB plan' },
  OOH: { key: 'OOH', title: 'OOH plan' },
};
